import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

const ArrowCircleDown = (props: any) => {
  return <ArrowCircleDownIcon {...props} />;
};

export default ArrowCircleDown;
